import styled from "styled-components";
import {FontFamily, FontSize, FontWeight, ThemesColors} from "../themes";
import {ReactComponent as SettingsIcon} from "../assets/icon/settingsBlue.svg"
import { ReactComponent as RightArrow } from "@assets/icon/right.svg";
import { ReactComponent as Plus } from "@assets/icon/plus.svg";
interface IAuthProps {
    color?: string;
    gap?: string;
    maxWidth?: string;
    cursor?: string;
    right?:string;
    content?:
        | "center"
        | "start"
        | "end"
        | "flex-start"
        | "flex-end"
        | "left"
        | "right"
        | "space-between"
        | "space-around"
        | "space-evenly"
        | "stretch";
    items?:
        | "center"
        | "start"
        | "end"
        | "flex-start"
        | "flex-end"
        | "stretch"
        | "baseline"
        | "normal";
    height?: string;
    padding?: string;
    radius?: string
    top?:string;
    isMood?: boolean;
}

const TitleParagraph = styled.p<IAuthProps>`
    color: ${({color}) => color || "#838383"};
`;

const FullNameTitle = styled.h4`
    font-size: ${FontSize.ms};
    text-transform: uppercase;
    color: ${ThemesColors.gray700};
    text-align: right;

    font-style: normal;
    font-weight: ${FontWeight.medium};
    line-height: 16px;
    letter-spacing: 1.25px;

    @media (max-width: 768px) {
        display: none !important;
        font-size: ${FontSize.mg};
    }

    @media (max-width: 480px) {
        font-size: ${FontSize.sm};
    }
`;

const ContainerFlexColumn = styled.div<IAuthProps>`
    display: flex;
    flex-direction: column;
    justify-content: ${({content}) => content || "center"};
    align-items: ${({items}) => items || "center"};
    padding: ${({padding}) => padding || "0"};
    background-color: ${({color}) => color || ThemesColors.popoverBackground};

    height: ${({height}) => height || "auto"};
    border-radius: ${({radius}) => radius || "0"};
    width: 100%;
    max-width: ${({maxWidth}) => maxWidth || "100%"};
    gap: ${({gap}) => gap || "0"};
    cursor: ${({cursor}) => cursor || "default"};
    padding-right: ${({right}) => right || "0"};
    @media (max-width: 500px) {
   
         h2 {
            font-size: 18px !important;
        }
    }
    @media (max-width: 480px) {
        margin-bottom: 10px;
    }
`;




const ContainerRowColumn = styled.div<IAuthProps>`
    display: flex;
    flex-direction: row;
    justify-content: ${({content}) => content || "center"};
    align-items: ${({items}) => items || "center"};
    height: ${({height}) => height || "auto"};
    padding: ${({padding}) => padding || "0"};
    padding-top: ${({top}) => top || "0"};
    padding-right: ${({right}) => right || "0"};
    width: 100%;
    background-color: ${({ color }) =>
             color || ThemesColors.popoverBackground};
 
    cursor: ${({cursor}) => cursor || "default"};
    max-width: ${({maxWidth}) => maxWidth || "100%"};: ${({items}) => items || "center"};
    gap: ${({gap}) => gap || "0"};
    @media (max-width: 768px) {
        display: flex;
    }

  
    @media(max-width:500px)
    {
        padding-right : 0 !important;
    }
 
`;

const ModalTitle = styled.span`
    font-weight: ${FontWeight.medium};
    font-size: ${FontSize.mg};
    color: ${ThemesColors.gray700};
    font-family: ${FontFamily.poppinsBlack};
`;

const SwitchTitle = styled.span`
    font-weight: ${FontWeight.normal};
    color: ${ThemesColors.gray700};
`;

const AttributesSettingsIcon = styled(SettingsIcon)`
    fill: ${ThemesColors.mainBlueDark500};
    width: 14px;
    height: 24px; 
`;


const CheckboxSpanWrapper = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: ${ThemesColors.mainBlueLight100}
    }
`;

const CheckboxTitleWrapper = styled.div`
    display: flex;
    gap: 10px;


   
`;

const TableSelectedWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`

const SelectedContainer = styled.div`
    display: flex;
    gap: 3px;
    align-items: center;
`
const ContainerRowColumnMini = styled.div<IAuthProps>`
    display: flex;
    flex-direction: row;
    justify-content: ${({content}) => content || "center"};
    align-items: ${({items}) => items || "center"};
    height: ${({height}) => height || "auto"};
    padding: ${({padding}) => padding || "0"};
    padding-top: ${({top}) => top || "0"};
    padding-right: ${({right}) => right || "0"};
    width: 100%;
    background-color: ${({ color }) =>
    color || ThemesColors.popoverBackground};
 
    cursor: ${({cursor}) => cursor || "default"};
    max-width: ${({maxWidth}) => maxWidth || "100%"};: ${({items}) => items || "center"};
    gap: ${({gap}) => gap || "0"};
   
    @media (max-width: 714px) {
  
    }
    @media (max-width: 575px)
    {
        justify-content: space-between !important;
    }
    @media(max-width:500px)
    {
        padding-right : 0 !important;
    }
   
`;

const TitleRowColumnMini = styled.div<IAuthProps>`
    display: flex;
    flex-direction: column;
    justify-content: ${({content}) => content || "center"};
    align-items: ${({items}) => items || "center"};
    height: ${({height}) => height || "auto"};
    padding: ${({padding}) => padding || "0"};
    padding-top: ${({top}) => top || "0"};
    padding-right: ${({right}) => right || "0"};
    width: 100%;
    background-color: ${({ color }) =>
    color || ThemesColors.popoverBackground};
 
    cursor: ${({cursor}) => cursor || "default"};
    max-width: ${({maxWidth}) => maxWidth || "100%"};: ${({items}) => items || "center"};
    gap: ${({gap}) => gap || "0"};

    @media (max-width: 575px)
    {
        justify-content: space-between !important;
    }
    @media(max-width:500px)
    {
        padding-right : 0 !important;
    }
`;


const ArrowIcon = styled(RightArrow)<{ rotate: boolean }>`
    transform: ${({ rotate }) => (rotate ? "rotate(180deg)" : "none")};
    transition: transform 0.5s ease;
`;
const PlusIcon = styled(Plus)`
 
`;


const PageTitleContainer =styled.div`
    display: flex;
    width: 100%;
    padding-right: 30px;
`


const PageActionsContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: end;
    padding-right: 21px;
`





export {
    TitleParagraph,
    FullNameTitle,
    ContainerFlexColumn,
    ContainerRowColumn,
    ContainerRowColumnMini,
    ModalTitle,
    SwitchTitle,
    AttributesSettingsIcon,
    CheckboxSpanWrapper,
    CheckboxTitleWrapper,
    TableSelectedWrapper,
    SelectedContainer,
    TitleRowColumnMini,
    ArrowIcon,
    PlusIcon,
    PageTitleContainer,
    PageActionsContainer,

};
